<template>
  <section class="section-wrapper section-8-wrapper" :style="sectionStyle">
    <!--<pre>{{ JSON.stringify(blockData[0], null, 2) }}</pre>-->
    <!--<pre>{{ JSON.stringify(componentData, null, 2) }}</pre>-->
    <div class="container section-8-container">
      <div class="row">
        <div class="col text-center">
          <a
            v-if="componentData.data.link.length > 0"
            class="section-8-section-title-link"
            :href="componentData.data.link"
            :target="componentData.data.target == 0 ? '_self' : '_blank'"
          >
            <h1 class="section-wrapper-title section-8-wrapper-title">
              {{ componentData.data.headline }}
            </h1>
          </a>
          <h1 v-else class="section-wrapper-title section-8-wrapper-title">
            {{ componentData.data.headline }}
          </h1>
        </div>
      </div>
      <div class="row">
        <div
          class="col col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 col-12"
        >
          <div>
            <div class="section-8-slide">
              <div class="section-8-slide-container">
                <div class="slider">
                  <div v-if="blockData[0]" id="section-8-slider" class="section-8-slider owl-carousel owl-theme">
                    <!-- eslint-disable vue/no-v-for-template-key, vue/no-useless-template-attributes -->
                    <template v-for="(post, index) in blockData[0]"
                    :key="index"
                    >
                        <div class="slider-card">
                            <div
                                class="d-flex justify-content-center align-items-center image-wrapper"
                            >
                                <a v-if="(typeof(post.link)=='string' && (post.link).length>0)" :href="genPostLink(componentData.type, post.id)" :target="typeof(post.target)=='string' && (post.target).length>0?post.target:'_blank'">
                                    <img :src="getImages(post.content, post.images)" :alt="post.title" />
                                </a>
                                <img v-else :src="getImages(post.content, post.images)" :alt="post.title" />
                            </div>
                        </div>
                    </template>
                    <!-- eslint-enable -->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import PublicService from "../services/public.service";
import FunctionService from "../services/function.service";

import "owl.carousel";
//import Vue from 'vue'

import jQuery from "jquery";
const $ = jQuery;
window.$ = $;

//import owlCarousel from 'owl.carousel'

export default {
  props: ["loggedIn", "componentData"],
  data() {
    return {
      brand: process.env.VUE_APP_APPNAME,
      AppConst: this.$AppConst,
      posts: [],
      blockData: [],
      //blockTitle: [],
    };
  },
  created() {
    var vm = this;
    this.getBlockData(this.componentData, vm);
  },
  computed: {
    sectionStyle() {
      let newStyle = {};
      if (this.componentData.data.bgImg.length > 0) {
        newStyle.backgroundImage = "url(" + this.componentData.data.bgImg + ")";
        if (
          this.componentData.data.bgImgFixed.length > 0 &&
          this.componentData.data.bgImgFixed == 1
        ) {
          newStyle.backgroundAttachment = "fixed";
        }
      } else {
        if (this.componentData.data.bgColor.length > 0) {
          newStyle.backgroundColor = this.componentData.data.bgColor;
        }
      }
      return newStyle;
    },
  },
  components: {
    //BannerItem
  },
  mounted() {
    this.initOwl();
  },
  methods: {
    getBlockData(cfgData, vm) {
      var resp = PublicService.getAllBlockPublicDataByType(cfgData);
      /*
      console.log("********************************************");
      console.log("resp: ");
      console.log(resp);
      console.log(typeof resp);
      */
      //if(typeof(resp) == 'object' && Object.prototype.hasOwnProperty.call(resp, "data")){
      if (typeof resp == "object") {
        var allData = [];
        resp.then(function (data) {
          //var dtCt = 0;
          data.forEach((dt) => {
            //console.log(dt.data);
            allData.push(dt.data);
            //vm.blockData.push(dt.data.child);
            vm.blockData.push(dt.data);
            //this.blockData.push(dt.data);
            /*
            console.log(cfgData.data.dataList[dtCt]);
            if(typeof(cfgData.data.dataList[dtCt])=='object' && typeof(cfgData.data.dataList[dtCt].dataHeadLine)=='string'){
                vm.blockTitle.push(
                cfgData.data.dataList[dtCt].dataHeadLine.length > 0
                    ? cfgData.data.dataList[dtCt].dataHeadLine
                    : ""
                );
            }
            dtCt++;
            */
            vm.$nextTick(function () {
               vm.initOwl();
            });
            vm.initOwl();
          });
        });
        //console.log(this.blockData);
        vm.initOwl();
      }
      //console.log("********************************************");
    },
    removeHTML: function (data) {
      return FunctionService.removeHTML(data);
    },
    displayHtmlContent: function (data) {
      return FunctionService.displayHtmlContent(data);
    },
    getImages: function (str, imgUrl) {
      return FunctionService.getImages(str, imgUrl);
    },
    displayEntity: function (str) {
      return FunctionService.displayEntity(str);
    },
    shorten: function (str, maxLen, separator = " ") {
      return FunctionService.shorten(str, maxLen, separator);
    },
    genPostLink: function (type, id) {
      return FunctionService.genPostLink(type, id);
    },
    initOwl() {
      $(".section-8-slider").owlCarousel({
        loop: true,
        autoHeight: false,
        autoplay: true,
        autoplayTimeout: 3000,
        autoplayHoverPause: true,
        dots: false,
        nav: true,
        navText: [
          '<i class="fa fa-angle-left" aria-hidden="true"></i>',
          '<i class="fa fa-angle-right" aria-hidden="true"></i>',
        ],
        //items: 2,
        lazyLoad: true,
        responsiveClass: true,
        margin: 20,
        responsive: {
          0: {
            items: 1,
          },
          600: {
            items: 2,
          },
          1000: {
            items: 7,
          },
        },
      });
    },
  },
};

/*
export default {
  props: ["loggedIn"],
  data() {
    return {
      brand: process.env.VUE_APP_APPNAME
    };
  },
  components: {
    BannerItem
  },
  methods: {
    logout() {
      this.$store.dispatch("logout");
    }
  }
};
*/
</script>

<style></style>
